/**
 * @packageDocumentation
 * @module dom/strategy
 */

import { TAttrs } from '../attribute/set_attrs';
import create from '../model/create';

export type t_region_algorithm = 'section' | 'drawer' | 'dialog' | 'fallback';
export type TRegionStrategy = Record<t_region_algorithm, (attributes: TAttrs) => HTMLElement>;

/**
 * A strategy for creating regions
 *
 * @example
 * Use f1 to parse the strategy.
 *
 * ```
 * // create a region element
 * f1.strategy('section', dom.strategy.region, 'section') => <section />
 * // create a region element builder and invoke
 * const createRegion = f1.strategy(dom.strategy.region)
 * createRegion('dialog') => <hi-dialog />
 * ```
 */
const RegionStrategy = {
  dialog(attributes: TAttrs) {
    return create(
      null,
      'hi-dialog',
      Object.assign(
        {
          opened: 'opened',
          modal: 'modal'
        },
        attributes
      )
    );
  },
  drawer(attributes: TAttrs) {
    return create(
      null,
      'hi-drawer',
      Object.assign(
        {
          direction: 'right',
          opened: 'opened',
          modal: 'modal'
        },
        attributes
      )
    );
  },
  section(attributes: TAttrs) {
    return create(null, 'section', attributes);
  },
  fallback(attributes: TAttrs) {
    return create(null, 'section', attributes);
  }
};

export default RegionStrategy;
